import { useCallback, useState } from "react";
import { Chip, Typography } from "@mui/material";

import { useAuth, useBanners, useUnits } from "../../../../contexts";
import * as s from "./styles";
import {
  BarChart,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Star,
} from "@mui/icons-material";
import { CURRENT_WEEK_DAY, RUSH_LEVELS } from "../../../../@data";
import { isCurrentTimeBetween } from "../../../../utils";

const Header = () => {
  const [showUnitInformations, setShowUnitInformations] = useState(false);
  const { client, isVisitant } = useAuth();
  const { units } = useUnits();
  const { setAutoPlayBannersCarosel } = useBanners();

  const handleShowUnitInformations = useCallback(() => {
    setAutoPlayBannersCarosel(showUnitInformations);
    setShowUnitInformations(!showUnitInformations);
  }, [setAutoPlayBannersCarosel, showUnitInformations]);

  const clientUnit = units.find((u) => u.unitId === client.unitId);
  const rushHourNow = clientUnit?.daysWithRushHoursList?.[
    CURRENT_WEEK_DAY.key
  ]?.filter((d) => isCurrentTimeBetween(d.startHour, d.endHour))?.[0];

  return (
    <s.Container>
      <div onClick={handleShowUnitInformations}>
        <Typography variant="caption">Olá</Typography>
        <Typography fontWeight={500}>{client.name}</Typography>
        {!isVisitant && (
          <s.SeeMoreButton variant="outlined" color="inherit" size="small">
            Ver {showUnitInformations ? "menos" : "mais"}
            {showUnitInformations ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </s.SeeMoreButton>
        )}
      </div>
      {!isVisitant && (
        <s.DetailsCollapse in={showUnitInformations}>
          <s.DetailsCotainer>
            <s.UnitRow>
              <img src={clientUnit?.imageUrl} alt={clientUnit?.name} />
              <div>
                <Typography variant="body2" fontWeight={300}>
                  Unidade
                </Typography>
                <Typography component="p" variant="body1" fontWeight={500}>
                  {clientUnit?.name}
                </Typography>
                {clientUnit?.deleted || !rushHourNow ? (
                  <Chip
                    icon={<BarChart sx={{ fontSize: 13 }} />}
                    label="Sem informações"
                    sx={{
                      fontSize: 9,
                      height: "1.1rem",
                      paddingLeft: "0.2rem",
                    }}
                  />
                ) : (
                  <Chip
                    icon={
                      <BarChart
                        sx={{ fontSize: 13 }}
                        style={{
                          color:
                            RUSH_LEVELS[rushHourNow.rushLevel].contrastColor,
                        }}
                      />
                    }
                    label={RUSH_LEVELS[
                      rushHourNow.rushLevel
                    ].label.toUpperCase()}
                    sx={{
                      fontSize: 9,
                      backgroundColor: RUSH_LEVELS[rushHourNow.rushLevel].color,
                      color: RUSH_LEVELS[rushHourNow.rushLevel].contrastColor,
                      height: "1.1rem",
                      paddingLeft: "0.2rem",
                    }}
                  />
                )}
              </div>
            </s.UnitRow>
            <s.DetailsBox>
              <div>
                <span>
                  {[...Array(client.level)].map((_, index) => (
                    <Star
                      key={`${client.name}-star-${index}`}
                      color="primary"
                      className={
                        client.level === 3 && index === 1 ? "middle" : ""
                      }
                    />
                  ))}
                  <Typography
                    variant="h6"
                    sx={{ position: "absolute", mb: -1.5 }}
                  >
                    {client.level}
                  </Typography>
                </span>
                <div>
                  <Typography variant="caption" fontWeight={300} component="p">
                    Plano atual
                    <Typography
                      variant="caption"
                      fontSize={11}
                      color="gray"
                      fontWeight={300}
                    >
                      {` • ${new Date(client.dueDate).toLocaleDateString()}`}
                    </Typography>
                  </Typography>
                  <Typography variant="body1" component="p">
                    {client.plan}
                  </Typography>
                </div>
              </div>
            </s.DetailsBox>
          </s.DetailsCotainer>
        </s.DetailsCollapse>
      )}
    </s.Container>
  );
};

export default Header;
